import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import SubjectIcon from '@material-ui/icons/Subject';

import DataTableToolbar from '../_Shared/DataTables/DataToolbar';
import DataTable from '../_Shared/DataTables/DataTable';
import CreateModal from '../_Shared/CreateModal';
import AppContent from '../_Shared/Layout/AppContent';
import Select from '../_Shared/SearchableDropdown';

const defaultWebsite = { name: '' };
const uuidv4 = require('uuid/v4');

class WebsiteList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showCreateModal: false,
            website: defaultWebsite,
            anchorEl: null
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleCreateModal = e => {
        const { showCreateModal } = this.state;
        this.setState({ showCreateModal: !showCreateModal, website: defaultWebsite });
    }

    handleInputChange = (name, value) => {
        this.setState((prevState, state) => {
            return { website: Object.assign({}, prevState.website, { [name]: value }) }
        });
    }

    selectElement = website => {
        this.setState({ website });
    }

    createWebsite = e => {
        const { onWebsiteAdded } = this.props;
        const { website } = this.state;
        onWebsiteAdded(Object.assign({}, website, { id: uuidv4().replace(/-/g, ''), formats: [] }));
        this.setState({ showCreateModal: false });
    }

    deleteWebsite = () => {        
        const { onWebsiteRemoved } = this.props;
        const { website } = this.state;
        onWebsiteRemoved(website);
        this.setState({ website: defaultWebsite, anchorEl: null });
    }

    render() {
        const { websites, channels, purchaseModels, loading, channelsLoading, purchaseModelsLoading, onEdit } = this.props;
        const { showCreateModal, website, anchorEl } = this.state;
        return (<AppContent>
            {
                loading && <LinearProgress variant="query" />
            }
            <DataTableToolbar title="Websites" numSelected={0} >
                <Tooltip title="Add New">
                    <IconButton onClick={this.toggleCreateModal} color="secondary"><AddCircleIcon /></IconButton>
                </Tooltip>
            </DataTableToolbar>
            {
                websites &&
                <DataTable columns={[{ label: 'Name', field: 'name' }]} anchorEl={anchorEl} rows={websites} toggleRowMenu={this.toggleRowMenu} 
                    onElementSelect={this.selectElement} onCloseToggleRowMenu={this.closeToggleRowMenu}>
                    <MenuItem onClick={() => onEdit(`/organisations/websites/${website.id}/manage/settings`, website)}>
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText inset primary="Settings" />
                    </MenuItem>
                    <MenuItem onClick={() => onEdit(`/organisations/websites/${website.id}/manage/formats`, website)}>
                        <ListItemIcon><SubjectIcon /></ListItemIcon>
                        <ListItemText inset primary="Formats" />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.deleteWebsite}>
                        <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </DataTable>
            }
            <CreateModal title="Create Website" open={showCreateModal} closeHandler={this.toggleCreateModal} saveHandler={this.createWebsite}>
                <Grid container item spacing={24}>
                    <Grid item xs>
                        <TextField autoFocus value={website.name} onChange={e => this.handleInputChange('name', e.target.value)} id="name" name="name" label="Website Name" type="text" fullWidth />
                    </Grid>
                </Grid>
                <Grid container item spacing={24}>
                    <Grid item xs>
                        {
                            channels &&
                            <Select options={[].concat(!channelsLoading && channels).map(x => { return { 'label': x.name, 'value': x.id } })} value={website.channelId} name="channelId" label="Channel"
                                onChange={value => this.handleInputChange('channelId', value)} placeholder={channelsLoading ? "Loading Channels..." : "Please select a Channel"} />
                        }
                    </Grid>
                </Grid>
                <Grid container item spacing={24}>
                    <Grid item xs>
                        {
                            purchaseModels &&
                            <Select options={[].concat(!purchaseModelsLoading && purchaseModels).map(x => { return { 'label': x.name, 'value': x.id } })}
                                    value={[].concat(website.purchaseModelIds).join(',')} name="purchaseModelIds" label="Purchase Models"
                                    onChange={value => this.handleInputChange('purchaseModelIds', value.split(','))} multiple={true}
                                    placeholder={purchaseModelsLoading ? "Loading Purchase Models..." : "Please select a Purchase Model"} />
                        }
                    </Grid>
                </Grid>
            </CreateModal>
        </AppContent>)
    }
}

WebsiteList.propTypes = {
    websites: PropTypes.array.isRequired,
};

export default WebsiteList;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Websites/WebsiteList.js